import { createAsyncThunk } from '@reduxjs/toolkit';
import { itemService, registerService } from 'services';
import { t_cpap_instructions } from 'types';

export const getCPAPDetail = createAsyncThunk<t_cpap_instructions, string>(
  'cpapDetail/getCPAPDetail',
  async (param) => {
    const response = await itemService.getDetailCPAP(param);
    const fields = await registerService.getDataStoreFields({ appId: 'CPAP', dataStoreId: 't_cpap_instructions' });
    const accessories: any = Object.entries(fields.data.fields);
    const arr =
      accessories.find(([_key, value]: [string, any]) => 'display_id' in value && value.display_id === 'accessories')[1]
        .options || [];

    const accItem = response.data.items[0].accessories?.toString().split(',');
    const newAcc = accItem?.length
      ? accItem?.map((value: any) => {
          const result = arr.find((a: any) => a.value === value);
          return result ? result.display_id : '';
        })
      : accItem;
    const optionGender =
      accessories.find(([_key, value]: [string, any]) => 'display_id' in value && value.display_id === 'gender')[1]
        .options || [];
    const genderId = optionGender.find((f: any) => f.value === response.data.items[0].gender);
    return { ...response.data.items[0], accessories: newAcc, gender: genderId ? genderId.option_id : '' };
  },
);
